import { render, staticRenderFns } from "./Exhibition.vue?vue&type=template&id=b87dbdb0&"
import script from "./Exhibition.vue?vue&type=script&lang=js&"
export * from "./Exhibition.vue?vue&type=script&lang=js&"
import style0 from "./Exhibition.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VHover,VImg})
